<template>
  <v-container fluid v-if="questionnaire">
    <v-card>
      <v-card-title color="secondary">{{ questionnaire.name }}</v-card-title>
      <v-card-text>{{ questionnaire.description }}</v-card-text>

      <v-divider inset></v-divider>
      <v-divider inset></v-divider>
      <v-divider inset></v-divider>
      <v-divider inset></v-divider>

      <v-form v-model="valid" style="font-family: 'Montserrat';">
        <v-card
          flat
          v-for="question in questionnaire.questionnaireQuestions"
          v-bind:key="question.id"
        >
          <v-row class="px-5 pt-5">
          </v-row>
          <v-row class="px-5" color="primary">
            <v-label>{{ question.question }}</v-label>
          </v-row>
          <v-row class="px-5">
            <v-textarea
              class="pt-5"
              v-model="question.answer"
              v-bind:class="{ required: question.required }"
              auto-grow
              rows="3"
              outlined
              counter="1000"
              label="Answer"
              :rules="[rules.required, rules.maxLength]"
              :required="question.required"
            ></v-textarea>
          </v-row>
        </v-card>
      </v-form>
    </v-card>
    <v-footer class="header-text">
      Our job is to keep you on track with your saving goals. QUBER is your
      virtual financial assistant. We will communicate with you via email, and
      notifications on your phone.
      <strong class="red--text text--lighten-1">
        For the best experience, make sure notifications are turned on for
        QUBER, and that emails do not go to your spam folder.</strong
      >
    </v-footer>
    <v-btn
      fixed
      bottom
      right
      rounded
      :disabled="!valid"
      color="secondary"
      v-if="submitVisible"
      @click="save"
      >Submit</v-btn
    >
    <v-overlay v-if="savingAnswers">
      <v-progress-circular v-if="savingAnswers" :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      bottom
      :color="snackbarColor"
      multi-line
      :timeout="5000"
    >
      {{ snackbarText }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: {
    submitVisible: {
      required: false,
      default: true
    }
  },
  data: () => ({
    questionnaire: [],
    valid: false,
    loadingQuestionnaire: false,
    savingAnswers: false,
    snackbar: false,
    snackbarColor: '',
    snackbarText: '',
    rules: {
      required: value => !!value || 'Answer is required.',
      maxLength: value => (value && value.length <= 1000) || 'Answer must not exceed 1000 characters.'
    }
  }),
  created () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.loadingQuestionnaire = true

      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES
      }/questionnaires/1/user/${sessionStorage.getItem('loggedInUser')}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse) {
        this.questionnaire = getResponse.data
      }
      this.loadingQuestionnaire = false
    },
    async save () {
      if (!this.allRequiredQuestionsAnswered()) return
      if (this.questionnaire) {
        this.savingAnswers = true
        const endpoint = `${
          process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES
        }/questionnaires/1/user/${sessionStorage.getItem('loggedInUser')}`
        var postResponse = await rh.default
          .put(endpoint, this.questionnaire, true)
          .catch(e => {
            this.errors.push(e)
            this.savingAnswers = false
          })
        this.$emit('save-questionnaire', JSON.stringify(postResponse.data))
        this.savingAnswers = false
      }
    },
    allRequiredQuestionsAnswered () {
      let unansweredQuestions = []
      for (var i = 0; i < this.questionnaire.questionnaireQuestions.length; i++) {
        var question = this.questionnaire.questionnaireQuestions[i]
        if (question.required && !question.answer) {
          unansweredQuestions.push(question.questionNumber)
        }
      }
      if (unansweredQuestions.length > 0) {
        this.snackbarText = 'Please answer required questions (' + unansweredQuestions + ')'
        this.snackbarColor = 'error'
        this.snackbar = true
        return false
      }
      this.snackbarText = 'Goals successfully saved!'
      this.snackbarColor = 'success'
      this.snackbar = true
      return true
    }
  }
}
</script>
